import { PlayerEvaluationDataResponse } from '../types/Evaluation';
import * as clientStorage from './client-storage';
import { StorageKey } from './client-storage';
/**
 * Saves the updated player evaluation data.
 * Currently logs to console — replace with actual API call.
 */
export async function savePlayerProfile(data: PlayerEvaluationDataResponse, playerId: number): Promise<{ success: boolean }> {
  console.log('Saving player evaluation:', JSON.stringify(data, null, 2));
  return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/players/evaluation-data/save?playerId=${playerId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${clientStorage.get(StorageKey.TOKEN)}`,
    },
    body: JSON.stringify(data),
  })
    // .then(response => response.json())
    .then(response => {
      if (response.ok) {
        console.log('Save result:', response);
        return { success: true };
      } else {
        console.error('Error saving player evaluation:', response.statusText);
        return { success: false };
      }
    })
    .catch(error => {
      console.error('Error saving player evaluation:', error);
      return { success: false };
    });
  // return new Promise((resolve) => {
  //   setTimeout(() => resolve({ success: true }), 500);
  // });
}
